export default {
  name: 'Aalert',
  props: {
    title: { type: String, default: () => '标题' },
    type: { type: String, default: () => '' },
    description: { type: String, default: () => '' },
    closable: { type: Boolean, default: () => true },
    center: { type: Boolean, default: () => false },
    closeText: { type: String, default: () => '知道了' },
    showIcon: { type: Boolean, default: () => true },
    effect: { type: String, default: () => 'light/dark' },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div>
        <el-alert
          title={this.title}
          type={this.type}
          description={this.description}
          closable={this.closable}
          center={this.center}
          close-text={this.closeText}
          show-icon={this.showIcon}
          effect={this.effect}
          on-close={this.cancel}
          {...{ attrs }}
        >
          {this.$slots.default}
        </el-alert>
      </div>
    );
  }
}